import intersection from 'lodash.intersection';

export default {
    /**
   * @param {string[]} permissions
   * @param {string} requiredPermission
   * @returns {boolean}
   */
    hasPermission (permissions, requiredPermission) {
        return permissions.includes(requiredPermission);
    },
    /**
   * @param {string[]} permissions
   * @param {string[]} requiredPermissions
   * @param {boolean} requireOneOfProvided
   * @returns {boolean}
   */
    hasPermissions (permissions, requiredPermissions, requireOneOfProvided = true) {
        if (Array.isArray(requiredPermissions) === false) {
            throw new Error('Required permissions should be an array.');
        }
        const commonPermissionCount = intersection(permissions, requiredPermissions).length;

        if (requireOneOfProvided === true) {
            return commonPermissionCount > 0;
        }

        return commonPermissionCount === requiredPermissions.length;
    }
};
